"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const React = __importStar(require("react"));
const components_1 = require("@smapiot/components");
const constants_1 = require("./constants");
const Footer = () => (React.createElement(components_1.PageFooter, { copyrightHtml: React.createElement(React.Fragment, null, constants_1.copyright), left: React.createElement(components_1.FooterMenu, { title: "Contact" },
        React.createElement(components_1.FooterLink, { url: "mailto:info@smapiot.com" },
            React.createElement("i", { className: "far fa-envelope" }),
            " ",
            constants_1.email),
        React.createElement(components_1.FooterLink, { url: `tel:${constants_1.phone}` },
            React.createElement("i", { className: "fas fa-phone" }),
            " ",
            constants_1.phone),
        React.createElement(components_1.FooterLink, { url: `fax:${constants_1.fax}` },
            React.createElement("i", { className: "fas fa-fax" }),
            " ",
            constants_1.fax)), right: React.createElement(components_1.FooterMenu, { title: "Legal" }, constants_1.legal.map((l) => (React.createElement(components_1.FooterLink, { key: l.link, url: l.link }, l.name)))) }));
exports.Footer = Footer;
